/** Kannada: the card interview: the questions, retries, readbacks, checks and summary, and its chips. */
export const interview = {
    "iv.start": "ನಿಮ್ಮ ಕಾರ್ಡ್ ಮಾಡೋಣ. ನಾನು ಕೆಲವು ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳುತ್ತೇನೆ; ಮಾತಾಡಿ ಅಥವಾ ಟೈಪ್ ಮಾಡಿ ಉತ್ತರಿಸಿ.",
    "iv.ask.trade": "ನೀವು ಯಾವ ಕೆಲಸ ಮಾಡುತ್ತೀರಿ?",
    "iv.ask.area": "ನೀವು ಯಾವ ಏರಿಯಾದಲ್ಲಿ ಕೆಲಸ ಮಾಡುತ್ತೀರಿ?",
    "iv.ask.rate_month": "ತಿಂಗಳಿಗೆ ಸಾಮಾನ್ಯವಾಗಿ ಎಷ್ಟು ತೆಗೆದುಕೊಳ್ಳುತ್ತೀರಿ?",
    "iv.ask.rate_visit": "ಒಂದು ಸಲ ಬಂದರೆ ಸಾಮಾನ್ಯವಾಗಿ ಎಷ್ಟು ತೆಗೆದುಕೊಳ್ಳುತ್ತೀರಿ?",
    "iv.ask.min": "ಕನಿಷ್ಠ ಎಷ್ಟಕ್ಕೆ ಮಾಡುತ್ತೀರಿ? ಇದು ಬೇರೆ ಯಾರಿಗೂ ಕಾಣುವುದಿಲ್ಲ.",
    "iv.band_month": "{city} ನಗರದಲ್ಲಿ {trade}: ಸಾಮಾನ್ಯವಾಗಿ ತಿಂಗಳಿಗೆ {low}–{high}.",
    "iv.band_visit": "{city} ನಗರದಲ್ಲಿ {trade}: ಸಾಮಾನ್ಯವಾಗಿ ಒಂದು ಸಲಕ್ಕೆ {low}–{high}.",
    "iv.band_none": "{trade}: ಈ ಕೆಲಸಕ್ಕೆ ಸಾಮಾನ್ಯ ದರ ಇನ್ನೂ ನಮ್ಮ ಬಳಿ ಇಲ್ಲ.",
    "iv.legal_min": "{trade}, ದಿನಕ್ಕೆ {hours} ಗಂಟೆ ಕೆಲಸಕ್ಕೆ ಕಾನೂನಿನ ಕನಿಷ್ಠ ಸಂಬಳ: ತಿಂಗಳಿಗೆ {min}.",
    "iv.band_seed": "ಸಾರ್ವಜನಿಕ ಮೂಲಗಳಿಂದ ಸಂಗ್ರಹಿಸಿದ್ದು, ಇನ್ನೂ ಯಾವ ಯೂನಿಯನ್ ಪರಿಶೀಲಿಸಿಲ್ಲ.",
    "iv.ask.languages": "{lang} ಅಲ್ಲದೆ ಬೇರೆ ಯಾವ ಭಾಷೆಗಳನ್ನು ಮಾತಾಡುತ್ತೀರಿ?",
    "iv.ask.about": "ಗ್ರಾಹಕರಿಗೆ ನಿಮ್ಮ ಕೆಲಸದ ಬಗ್ಗೆ ಒಂದು ಸಾಲು ಹೇಳಿ, ಅಥವಾ 'ಬಿಡಿ' ಎನ್ನಿ.",
    "iv.ask.ask_first": "{item} ಇದ್ದರೆ, ಬೆಲೆ ಹೇಳುವ ಮೊದಲು ನಿಮ್ಮನ್ನು ಕೇಳಲೇ?",
    "iv.ask.auto": "ಗ್ರಾಹಕರು ನಿಮ್ಮ ಬೆಲೆಯೊಳಗೆ ಒಪ್ಪಿದರೆ, ನಿಮ್ಮ ಪರವಾಗಿ ನಾನೇ ಸಹಿ ಮಾಡಲೇ?",
    "iv.again.trade": "ಕೆಲಸದ ಹೆಸರನ್ನು ಕೆಲವೇ ಪದಗಳಲ್ಲಿ ಹೇಳಿ, ಉದಾಹರಣೆಗೆ ಅಡುಗೆ, ಎಲೆಕ್ಟ್ರಿಷಿಯನ್ ಅಥವಾ ದರ್ಜಿ.",
    "iv.again.area": "ಏರಿಯಾದ ಹೆಸರು ಹೇಳಿ, ಅಥವಾ ಕೆಳಗೆ ಒತ್ತಿ.",
    "iv.again.amount": "ರೂಪಾಯಿಯಲ್ಲಿ ಮೊತ್ತ ಹೇಳಿ, ಉದಾಹರಣೆಗೆ ಎಂಟು ಸಾವಿರ.",
    "iv.again.yes_no": "ಹೌದು ಅಥವಾ ಇಲ್ಲ ಎನ್ನಿ.",
    "iv.again.languages": "ಒಂದು ಭಾಷೆಯ ಹೆಸರು ಹೇಳಿ, ಅಥವಾ 'ಯಾವುದೂ ಇಲ್ಲ' ಎನ್ನಿ.",
    "iv.check_amount": "ನೀವು ಹೇಳಿದ್ದು {price} ತಾನೇ?",
    "iv.got_rate": "ಸಾಮಾನ್ಯ ದರ {price}, ಬರೆದುಕೊಂಡೆ.",
    "iv.got_min": "ಕನಿಷ್ಠ {price}, ಬರೆದುಕೊಂಡೆ. ಇದು ಬೇರೆ ಯಾರಿಗೂ ಕಾಣುವುದಿಲ್ಲ.",
    "iv.err_min": "ಕನಿಷ್ಠ ಬೆಲೆ ನಿಮ್ಮ ಸಾಮಾನ್ಯ ದರ {price} ಗಿಂತ ಹೆಚ್ಚು ಇರಬಾರದು. ಮತ್ತೆ ಹೇಳಿ.",
    "iv.err_private": "ಇದು ಫೋನ್ ನಂಬರ್ ಅಥವಾ ಯುಪಿಐ ಐಡಿ ತರಹ ಇದೆ. ಕಾರ್ಡ್ ಎಲ್ಲರಿಗೂ ಕಾಣುತ್ತದೆ, ಹಾಗಾಗಿ ಅದನ್ನು ಸೇರಿಸಬೇಡಿ.",
    "iv.err_long": "ಒಂದು ಚಿಕ್ಕ ಸಾಲಿನಲ್ಲಿ ಹೇಳಿ.",
    "iv.summary": "ನಿಮ್ಮ ಕಾರ್ಡ್: {trades}, ಏರಿಯಾ {area}, ಸಾಮಾನ್ಯ ದರ {rate}.",
    "iv.summary_about": 'ಗ್ರಾಹಕರು ಇದನ್ನು ಓದುತ್ತಾರೆ: "{about}"',
    "iv.summary_auto_on": "ಗ್ರಾಹಕರು ನಿಮ್ಮ ಬೆಲೆಯೊಳಗೆ ಒಪ್ಪಿದರೆ, ನಿಮ್ಮ ಪರವಾಗಿ ನಾನೇ ಸಹಿ ಮಾಡುತ್ತೇನೆ.",
    "iv.summary_auto_off": "ಯಾವುದೇ ಒಪ್ಪಂದಕ್ಕೆ ಸಹಿ ಮಾಡುವ ಮೊದಲು ನಿಮ್ಮನ್ನು ಕೇಳುತ್ತೇನೆ.",
    "iv.summary_min": "ನಿಮ್ಮ ಕನಿಷ್ಠ ಬೆಲೆ: {min}. ಇದು ಈ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತದೆ.",
    "iv.confirm": "ಇದನ್ನು ಬೋರ್ಡ್‌ಗೆ ಹಾಕಲೇ?",
    "iv.what_change": "ಏನು ಬದಲಾಯಿಸಲಿ?",
    "iv.published": "ಆಯಿತು. ಈಗ {area} ಹತ್ತಿರದ ಗ್ರಾಹಕರು ನಿಮ್ಮನ್ನು ಹುಡುಕಬಹುದು.",
    "iv.skip": "ಬಿಡಿ",
    "iv.none": "ಬೇರೆ ಯಾವುದೂ ಇಲ್ಲ",
    "iv.later": "ನಂತರ",
    "iv.resume": "ಕಾರ್ಡ್ ಮಾಡುವುದನ್ನು ಮುಂದುವರಿಸಿ",
    "iv.by_voice": "ಮಾತಾಡಿ ತುಂಬಿಸಿ",
};
//# sourceMappingURL=interview.js.map